module.exports = __webpack_public_path__ + "assets/svg/Icons/32/newsfeed-blue-9a7b3b.svg";